const tools = require('../../tools')
const { getLocationsWithConfigurations } = require('./configuration-docs')

exports.getByIds = async (state, locationIds, date, options) => {
  const funderOrRouteFilter = tools.getUserFilter(state.user)

  const isoDate = new Date(date).toJSON()
  const docs = await state.dal.location.getRawDocByIds(state, locationIds)

  // If you use this you have to apply the filter in next step
  if (options && options.raw) {
    return docs
  }

  return getLocationsWithConfigurations(state, docs, {
    date: isoDate,
    funderOrRouteFilter
  })
}
